/** Pul ko'rinishi va hisob-kitob (test: money.test.ts). Backend bilan bir xil yaxlitlash (2 xona, yarmi yuqoriga). */
import { dayjs, formatDate, formatMoney } from "@/lib/utils";
import type { Money } from "@/features/budget/types";
import type { Currency, Transaction, TxKind } from "./types";

export const num = (v: Money | null | undefined): number => (v === null || v === undefined || v === "" ? 0 : Number(v));

const round2 = (n: number) => Math.round((n + Number.EPSILON) * 100) / 100;

/** Valyuta almashtirish (1 USD = rate UZS); kurs yo'q -- null */
export function convert(amount: number, from: Currency, to: Currency, rate: number | null): number | null {
  if (from === to) return amount;
  if (!rate) return null;
  return from === "USD" ? round2(amount * rate) : round2(amount / rate);
}

/** "UZS 1,265,000" / "$100"; ishora bilan: "+$100", "−UZS 5,000" */
export function fmt(value: Money | null | undefined, currency: Currency = "USD", signed?: "in" | "out"): string {
  if (value === null || value === undefined || value === "") return "—";
  const text = formatMoney(Math.abs(num(value)), currency);
  if (!signed) return num(value) < 0 ? `−${text}` : text;
  return `${signed === "in" ? "+" : "−"}${text}`;
}

/** Daftar qatoridagi tur nomi uchun tarjima kaliti */
export const kindKey = (kind: TxKind) => `money.kinds.${kind}`;

/** Grafik/ro'yxat yorlig'i: xarajatda kategoriya (sozlamadagi nom), qolganida tur nomi */
export function categoryLabel(c: { kind: TxKind; category: string }, t: (key: string) => string): string {
  return c.category || t(kindKey(c.kind));
}

/** Bog'langan to'lov (xarajat, maosh, bonus, carrier, o'tkazma) -- summasi va sanasi daftardan o'zgarmaydi */
export const isLinked = (tx: Pick<Transaction, "kind">) => !["income", "adjustment"].includes(tx.kind);

/** O'zgarish foizi: oldingi oy 0 bo'lsa -- null */
export function changePct(current: number, previous: number): number | null {
  if (!previous) return null;
  return Math.round(((current - previous) / Math.abs(previous)) * 100);
}

/** Formadagi vaqt maydoni uchun hozirgi vaqt (soniya bilan); yozuv aniq vaqt bilan saqlanadi (2026-10-18) */
export const nowTime = () => dayjs().format("HH:mm:ss");

/** Yozuvning aniq vaqti "14:32:05"; noma'lum bo'lsa bo'sh */
export const timeText = (at: string | null | undefined): string => (at ? dayjs(at).format("HH:mm:ss") : "");

/** Sana va (bo'lsa) vaqt: "Oct 18, 2026 14:32:05" */
export const whenText = (p: { date: string; at?: string | null }): string => (p.at ? `${formatDate(p.date)} ${timeText(p.at)}` : formatDate(p.date));
